import React from "react";

import creditCard from "../../assets/paymentMethodImages/credit-card.svg";
import debitCard from "../../assets/paymentMethodImages/debit-card.svg";
import instantEFT from "../../assets/paymentMethodImages/instantEFT.svg";
import scanToPay from "../../assets/paymentMethodImages/scan-to-pay.svg";
import snapscan from "../../assets/paymentMethodImages/snapscan.svg";
import zapper from "../../assets/paymentMethodImages/zapper.svg";

/**
 * @typedef {Object} EnabledMap
 * @property {boolean} creditCard
 * @property {boolean} debitCard
 * @property {boolean} instantEFT
 * @property {boolean} scanToPay
 * @property {boolean} snapscan
 * @property {boolean} zapper
 */

/** Mapping of payment method keys to image sources. */
const IMAGE_MAP = {
  creditCard,
  debitCard,
  instantEFT,
  scanToPay,
  snapscan,
  zapper,
};

/**
 * Renders payment method images based on the `enabled` flags.
 *
 * @param {Object} props
 * @param {string} [props.imageHeight='40px'] - Height for the payment method images.
 * @param {EnabledMap} [props.enabled] - Flags controlling visibility of each payment method.
 * @returns {JSX.Element}
 */
const PaymentMethodImages = ({
    imageHeight = '40px',
  enabled = {
    creditCard: true,
    debitCard: true,
    instantEFT: true,
    scanToPay: true,
    snapscan: true,
    zapper: true,
  },
}) => {
  return (
    <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
      {Object.entries(IMAGE_MAP).map(([key, src]) =>
        enabled[key] ? (
          <img
            key={key}
            src={src}
            alt={key}
            style={{ height: imageHeight, objectFit: "contain" }}
          />
        ) : null
      )}
    </div>
  );
};

export default PaymentMethodImages;